//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Drawings.js";
import "../no/TaggedObject.js";
let d=[[[0,"CustomizedViewLabel",1,0],[0,"IncludeParentheses",1,0],[0,"LabelCharacterHeightFactor",1,0],[0,"LabelParentDisplay",1,0],[0,"LabelPosition",1,0],[0,"LabelPrefix",1,0],[0,"LetterFormat",1,0],[0,"ParentLabelPrefix",1,0],[0,"PrefixCharacterHeightFactor",1,0],[0,"ReferenceToShow",1,0],[0,"ScaleCharacterHeightFactor",1,0],[0,"ScalePosition",1,0],[0,"ScalePrefix",1,0],[0,"ShowViewLabel",1,0],[0,"ShowViewScale",1,0],[0,"TextGapFactor",1,0],[0,"TextPlacement",1,0],[0,"ValueFormat",1,0],[0,"ViewLabelOption",1,0]],[[["nText"],"GetCustomizedViewLabelText",{R_:{customizedText:""}},0,0],[["customizedText"],"SetCustomizedViewLabelText",{},1,0],[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.Drawings.ViewDetailLabelBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Drawings.ViewDetailLabelBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Drawings.ViewDetailLabelBuilder.LabelParentDisplayTypes = Object.freeze({
    "None" : "None", "Circle" : "Circle", "Note" : "Note", "Label" : "Label", "Embedded" : "Embedded", "Boundary" : "Boundary", "LabelOnBoundary" : "LabelOnBoundary"});

SPLM.Drawings.ViewDetailLabelBuilder.LabelParentTextPlacement = Object.freeze({
    "BeforeOrAfterStub" : "BeforeOrAfterStub", "AboveStub" : "AboveStub"});

export default SPLM;